<template>
  <div class="bank-card-dialog">
    <custom-dialog :title="model.type === 'edit' ? $t('bank_card_dialog.bjyhkxx') : $t('bank_card_dialog.tjyhkxx')" :appendToBody="true" :visible="visible" width="600px" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="bankCardForm" ref="bankCardForm" :rules="rules" :validate-on-rule-change="false" label-position="left" label-width="120px">
          <el-row>
            <el-form-item :label="$t('bank_card_dialog.zhang_hu_ming_cheng')" prop="depositName">
              <el-input v-model="bankCardForm.depositName" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('bank_card_dialog.zhang_hao')" prop="depositNumber">
              <el-input v-model="bankCardForm.depositNumber" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('bank_card_dialog.zhi_hang_ming_cheng')" prop="depositBank">
              <el-input v-model="bankCardForm.depositBank" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('bank_card_dialog.zhang_hu_lei_xing')" prop="depositType">
              <custom-select v-model="bankCardForm.depositType" code="bank_deposit_type" :placeholder="$t('Common.com_please_select')" style="width: 420px"></custom-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('bank_card_dialog.shuo_ming')" prop="bankcardDesc">
              <el-input type="textarea" :rows="3" v-model="bankCardForm.bankcardDesc" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="warning" @click="addAddress">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      bankCardForm: {
        // bankCode: '', // 开户行
        bankName: '', // 开户行名称
        depositName: '', // 账户名称
        depositNumber: '', // 账号
        depositBank: '', // 支行名称
        depositType: '', // 账号类型
        bankcardId: '',
        depositPurpose: [], // 账户类型(传空 不用了)
        bankcardDesc: '', // 账户用途
        // bizId: '',
        partnerId: '', // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
        partnerOrgId: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        // 开户行
        depositName: [
          {
            required: true,
            message: this.$t('bank_card_dialog.qtxzhmc'),
          },
          { max: 50, message: ' ' },
        ], // 账户名称
        depositNumber: [
          {
            required: true,
            message: this.$t('bank_card_dialog.qtxzh'),
          },
          { max: 30, message: ' ' },
        ], // 账号
        depositBank: [
          {
            required: true,
            message: this.$t('bank_card_dialog.qtxzhmc'),
          },
          { max: 50, message: ' ' },
        ], // 支行名称
        depositType: [
          {
            required: true,
            message: this.$t('bank_card_dialog.qxzzhlx'),
          },
        ],
        // 账户用途
        depositPurpose: [
          {
            type: 'array',
            required: true,
            message: this.$t('bank_card_dialog.qxzzhyt'),
            trigger: 'blur',
          },
        ],
        // 说明
        bankcardDesc: [
          {
            required: true,
            message: this.$t('bank_card_dialog.qxzsm'),
          },
        ], // 账号类型
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.partnerOrgId) {
        // this.bankCardForm.partnerId = this.model.partnerId;(都拿不到由后端来取)
        // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
        this.bankCardForm.partnerOrgId = this.model.partnerOrgId;
      } else {
        this.bankCardForm.partnerOrgId = this.$store.state.userInfo.rootOrgId;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.bankCardForm, this.model.data.item);
      }
    },
    onBankCode(item) {
      this.bankCardForm.bankName = item.bankName;
    },
    // 保存基本信息
    addAddress: function () {
      this.$refs.bankCardForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.$putJSON(apis.partnerBankcardUpdate, this.bankCardForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_edit_success'),
                type: 'success',
              });
              this.visible = false;
              this.$emit('success');
            }
          });
        } else if (this.model.partnerId) {
          // 合作伙伴
          this.$postJSON(apis.PartnerBankcardAddByOrgId, this.bankCardForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.visible = false;
              this.$emit('success');
            }
          });
        } else {
          // 个人
          this.$postJSON(apis.partnerBankcardAdd, this.bankCardForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.visible = false;
              this.$emit('success');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.bank-card-dialog {
  .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 24px;
    .tag {
      width: 4px;
      height: 15px;
      background-color: #00afff;
      left: 0;
    }
  }
}
</style>
